import { forwardRef } from 'react';
import { Button, ButtonProps } from '@repo/atomic-components';
import { classNames } from 'primereact/utils';

// `forwardRef` so callers (e.g. PrimeReact Sidebar's `closeIconRef`) can
// still grab the underlying Button instance for keyboard-focus handling.
export const OutlineButton = forwardRef<Button, ButtonProps>(({ className, ...props }, ref) => (
  <Button {...props} ref={ref} outlined className={classNames('hover:!bg-fletchers-gray-50 !px-4', className)} />
));
OutlineButton.displayName = 'OutlineButton';
